import { isNotNil } from '@benzinga/utils';
import { absColDef, AdvancedColDef } from '../helpers/advancedHeader';
import { NO_VALUE } from '../../Ticker';

export const SetColDef = (colDef: AdvancedColDef): AdvancedColDef => {
  const { filterParams: colDefFilterParams, ...restColDef } = colDef;
  return {
    filter: 'agSetColumnFilter',
    valueFormatter: params => (isNotNil(params.value) && params.value !== '' ? params.value : NO_VALUE),
    ...restColDef,
    ...absColDef(colDef),
    filterParams: colDefFilterParams ?? {},
  };
};
